import Icon from "@mui/material/Icon";
import Logout from "views/logout/logout";
import CountryDropdown from "views/selectCountry/countryDropdown";

// CR specific views
import CRHome from "views/countries/cr/home";
import CRFlag from "assets/images/FlagCR.webp";
import CRMyTools from "views/countries/cr/myTools";
import CRLinksSettings from "views/countries/cr/settings/links";
import CRLinksRoleSettings from "views/countries/cr/settings/linksRole";
import CRHomeLinksSettings from "views/countries/cr/settings/homeLinks";
import CRRolesSettings from "views/countries/cr/settings/roles";
import CRUserRolesSettings from "views/countries/cr/settings/userRoles";
import CRMenuLevel2Settings from "views/countries/cr/settings/menuLevel2";

// PE specific views
import PEHome from "views/countries/pe/home";
import PEFlag from "assets/images/FlagPeru.png";

// Retrieve user session data and selected country from localStorage
const datosRecuperados = localStorage.getItem("sesion");
const selectedCountry = localStorage.getItem("selectedCountry");

let showSelectCountry = true;
let showSettings = false;
let userCountry = selectedCountry || "default"; // Default value if no country is in localStorage

if (datosRecuperados) {
  const parsedData = JSON.parse(datosRecuperados);
  const rolsArray = parsedData.rols;

  // Map countries only if rolsArray exists and has roles
  const paises = rolsArray?.map((rol) => rol.country.countryName) || [];

  if (paises.length === 1) {
    showSelectCountry = false;
  }

  if (rolsArray && rolsArray.length > 0) {
    const rolesByCountry = rolsArray.filter(
      (role) => role.country?.countryName === selectedCountry
    );

    if (rolesByCountry.length > 0) {
      const hasSuperAdmin = rolesByCountry.some(
        (role) => role.roleName === "SuperAdmin"
      );

      showSettings = hasSuperAdmin ? true : showSettings;

      userCountry = selectedCountry;
    }
  }
}

// Define country-specific routes
const CRRoutes = [
  {
    name: "Home",
    icon: <img src={CRFlag} alt="CR" style={{ width: 20, height: 14 }} />,
    route: "/views/countries/cr/home",
    component: <CRHome />,
  },
  {
    name: "My Tools",
    icon: <Icon>view_day</Icon>,
    route: "/views/countries/cr/mytools",
    component: <CRMyTools />,
  },
  ...(showSettings
    ? [
        {
          name: "Settings",
          icon: <Icon>settings</Icon>,
          columns: 1,
          display: "none",
          rowsPerColumn: 2,
          collapse: [
            {
              name: "",
              collapse: [
                {
                  name: "Categories",
                  icon: <Icon>folder</Icon>,
                  route: "/views/countries/cr/settings/menuLevel2",
                  component: <CRMenuLevel2Settings />,
                },
                {
                  name: "Links",
                  icon: <Icon>view_day</Icon>,
                  route: "/views/countries/cr/settings/links",
                  component: <CRLinksSettings />,
                },
                {
                  name: "Roles",
                  icon: <Icon>badge</Icon>,
                  route: "/views/countries/cr/settings/roles",
                  component: <CRRolesSettings />,
                },
                {
                  name: "Links by Role",
                  icon: <Icon>link</Icon>,
                  route: "/views/countries/cr/settings/linksRole",
                  component: <CRLinksRoleSettings />,
                },
                {
                  name: "User Roles",
                  icon: <Icon>assignment_ind</Icon>,
                  route: "/views/countries/cr/settings/userRoles",
                  component: <CRUserRolesSettings />,
                },
                {
                  name: "Home Links",
                  icon: <Icon>home</Icon>,
                  route: "/views/countries/cr/settings/homeLinks",
                  component: <CRHomeLinksSettings />,
                },
              ],
            },
          ],
        },
      ]
    : []),
];

const PERoutes = [
  {
    name: "Home",
    icon: <img src={PEFlag} alt="PE" style={{ width: 20, height: 14 }} />,
    route: "/views/countries/pe/home",
    component: <PEHome />,
  },
  ...(showSettings
    ? [
        {
          name: "Settings",
          icon: <Icon>settings</Icon>,
          columns: 1,
          display: "none",
          rowsPerColumn: 2,
          collapse: [
            {
              name: "",
              collapse: [],
            },
          ],
        },
      ]
    : []),
];

// Define a default route for the country dropdown
const defaultRoutes = [
  ...(showSelectCountry
    ? [
        {
          name: "Select Country",
          icon: <Icon>public</Icon>,
          route: "/views/selectCountry",
          component: <CountryDropdown />,
        },
      ]
    : []),
];

// Select routes to load based on the country
const routes =
  userCountry === "Costa Rica"
    ? [...CRRoutes, ...defaultRoutes]
    : userCountry === "Peru"
    ? [...PERoutes, ...defaultRoutes]
    : [...defaultRoutes]; // Include the CountryDropdown route if no country matches

// Add a default route for logout
routes.push({
  name: "Logout",
  icon: <Icon style={{ color: "red" }}>power_settings_new</Icon>,
  route: "/views/logout",
  component: <Logout />,
});

export default routes;
